const sizes = {
  oval: {
    small: "7x9mm",
    medium: "13x18mm",
    large: "16x22mm",
  },
  classic: {
    small: "8x8mm",
    medium: "12x12mm",
    large: "18x18mm",
  },
}

export function getSizeLabel(style: string, size: string) {
  if (["small", "medium", "large"].indexOf(size) === -1) {
    throw new Error(`Invalid size: ${size}`)
  }

  if (["classic", "oval"].indexOf(style) === -1) {
    return sizes.classic[size]
  }

  return sizes[style][size]
}
